import { googleMapsKey, rootURL } from '../constants';
import connectLabels from '../utils/connectLabels';
import domWrap from '../utils/domWrap';
import formField from '../utils/formField';
import getDistance from '../utils/getDistance';
import h from '../utils/htm';
import http from '../utils/http';
//Potential Quote Form Validation Separation
//import { formValidation } from '../../scripts/quoteSubmitValidation';
import { formValidation } from '../utils/FormValidation'
import { locationFromPostal } from '../utils/locationFromPostal';


export default async form => { // 'form[type]:not([type*="Calc"])'

	const formType = form.getAttribute('type');

    if (formType && (formType === 'DownloadGuide' || formType === 'RCOGuide' || formType === 'Newsletter' || formType === 'Cascadia' || formType === 'TRS')) {
        whitePaper(form, formType);
        return;
	}

	const captchaKey = form.getAttribute('data-captchakey');
	const captchaProperty = form.getAttribute('data-captchaproperty');
	const saveButton = form.querySelector('input[type = "Submit"]');
	const scriptFields = [...document.querySelectorAll('script[type="fields"]')];
	let isProcessing = false;

	if (scriptFields.length < 1) return;

	if (!saveButton)
		saveButton = {
			classList: {
				add: (element) => { }
			},
			value: ''
		};

	connectLabels(form);

	scriptFields.forEach(script => {
		script.insertAdjacentHTML('afterend', [...eval(script.innerHTML)].reduce((html, item) => html + formField(item), ''));
		script.remove();
	});

	[...form.querySelectorAll('select[children]')].forEach(select => select.addEventListener('change', () => {
		select.getAttribute('children').split(',').forEach(childId => {
			var child = form.querySelector('select#' + childId),
				options = (select.querySelector('option:checked').getAttribute(childId.toLowerCase()) || '').split(',');
			if (!child) return;
			[...child.querySelectorAll('option:not([disabled])')].forEach(option => option.remove());
			child.insertAdjacentHTML('beforeend', options.filter(String).reduce((html, item) => html + h('option value="' + item + '"', item), ''));
			child.value = '';
			child.style.display = child.querySelectorAll('option:not([disabled])').length > 0 ? '' : 'none';
		});
	}));

	[...form.querySelectorAll('select')].forEach(select => {
		validateSelect(select);
		select.addEventListener('change', () => validateSelect(select));
	});

	[...form.querySelectorAll('select[name="TruckModel"]')].forEach(select => {
		const matches = [...form.querySelectorAll('select[name="TruckModel"] option')]
			.map(x => { return { value: x.getAttribute('value') }; })
			.filter(x => { return isReferrerMatch(x.value); });
		const match = (matches && matches.length > 0) ? matches[0].value : '';
		select.value = match;
		domWrap(select).trigger('change');
	});

	[...form.querySelectorAll('[dealer-selector]')].forEach(dealerSelect);

	[...form.querySelectorAll('[location-check]')].forEach(locationCheck);

	[...form.querySelectorAll('[location-from-postal]')].forEach(locationFromPostal);

	const fnOnComplete = (response) => {
		isProcessing = false;
		setButtonState(saveButton, isProcessing);

		if (response) {

			const tag = form.querySelector('input[name="tag"]')?.value

			if (tag && tag !== '' && gtag_report_conversion
				&& typeof gtag_report_conversion === 'function')
				gtag_report_conversion(tag);

			const thankyou = form.querySelector('.thankyou');

			if (thankyou) {
				const href = thankyou.getAttribute('href');

				if (href && href !== '') {
					const distanceElement = form.elements['Dealer[distance]'];
					const distance = (distanceElement)
						? distanceElement.value
						: 'Unknown';

					const firstNameElement = form.elements['FirstName'];
					const firstName = (firstNameElement)
						? firstNameElement.value
						: 'Unknown';

					const lastNameElement = form.elements['LastName'];
					const lastName = (lastNameElement)
						? lastNameElement.value
						: 'Unknown';

					const dealerIdElement = form.elements['DealerCode'];
					const dealerId = (dealerIdElement)
						? dealerIdElement.value
						: 'Unknown';

					const truckModelElement = form.elements['TruckModel'];
					const truckModel = (truckModelElement)
						? truckModelElement.value
						: 'Unknown';

					let newLocation = `${href}?type=truck`;

					if (response.token)
						newLocation += `&surveytoken=${response.token}`;

					newLocation += `&distance=${distance}&firstName=${firstName}&lastName=${lastName}&dealerId=${dealerId}&truckModel=${truckModel}`;

					window.location.href = newLocation;

				} else {
					form.innerHTML = thankyou.innerHTML;
				}
			}

			if ((navigator.userAgent || navigator.vendor || window.opera).match(/Android/i)) {
				setTimeout(() => document.body.scrollTop = form.offsetTop - 70, 100);
			}
		}
	};

	const setToken = (token) => {
		const field = document.createElement('input');
		const name = (typeof captchaProperty === 'string'
			&& captchaProperty.length > 0)
			? captchaProperty
			: 'CaptchaToken';
		field.setAttribute('type', 'hidden');
		field.setAttribute('id', name);
		field.setAttribute('name', name);
		field.setAttribute('value', token);

		form.appendChild(field);

		sendLead(formType, form, fnOnComplete)
	};

	form.addEventListener('submit', event => {
		event.preventDefault();

		if (isProcessing)
			return;

		isProcessing = true;

		setButtonState(saveButton, isProcessing)

		const validation = formValidation(formType, form);

		if (!validation.validate()) {
			fnOnComplete();
			return;
		}

		if (typeof captchaKey === 'string' && captchaKey.length > 0) {
			if (!window.grecaptcha)
				loadCaptcha(captchaKey, setToken);
			else
				getCaptchaToken(captchaKey, setToken);
		} else {
			sendLead(formType, form, fnOnComplete)
		}

	});
}

function setButtonState(btn, isProcessing) {
	if (isProcessing) {
		btn.classList.add('form-button-loading');
		btn.setAttribute('data-value', btn.value);
		btn.value = '';
	} else {
		btn.classList.remove('form-button-loading');
		btn.value = btn.getAttribute('data-value');
	}
}

function getCaptchaToken(captchaKey, fnOnComplete) {
	window.grecaptcha.ready(() => {
		window.grecaptcha
			.execute(captchaKey, { action: 'submit' })
			.then(token => {
				fnOnComplete(token);
			});
	});
}

function loadCaptcha(captchaKey, fnOnComplete) {
	const script = document.createElement('script');
	script.setAttribute('type', 'text/javascript');
	script.setAttribute('src', `https://www.google.com/recaptcha/api.js?render=${captchaKey}`);
	script.addEventListener('load', () => {
		getCaptchaToken(captchaKey, fnOnComplete)
	});
	document.body.appendChild(script);
}

function sendLead(formType, form, fnOnComplete) {

	const headers = {};

	if (form['X-CSRF-TOKEN-FTL'])
		headers['X-CSRF-TOKEN-FTL'] = form['X-CSRF-TOKEN-FTL'].value;

	http(`/${form.getAttribute('type')}`)
		.create(formData(form), headers)
		.then((response) => {
			fnOnComplete(response);
		}).catch((e) => {
			console.error(e);
			form.querySelector('.errors').innerHTML =
				h('p', 'There was an error submitting. Please check your connection and try again.');
			fnOnComplete();
		});
}

class WhitePaperForm {
	constructor(form) {
		this.Form = form;
		if (!this.Form)
			console.error("ArgumentNullException: Form");

		this.SubmitButton = form.querySelector('[type="submit"]');
		if (!this.SubmitButton)
			console.error("ArgumentNullException: SubmitButton");

		this.Token = form.querySelector('input[name="X-CSRF-TOKEN-FTL"]');
		if (!this.Token)
			console.error("ArgumentNullException: Token");

		this.Api = undefined;

		this.Fields = {};

		this.LoadingText = 'Loading';

		this.CaptchaKey = undefined;

	}

	getData() {
		const data = {};

		for (let x in this.Fields)
			data[x] = this.Fields[x].element.value;

		return data;
	}

	onComplete() { }

	sendLead() {
		const headers = {};

		if (this.Form['X-CSRF-TOKEN-FTL'])
			headers['X-CSRF-TOKEN-FTL'] = this.Token.value;

		const data = this.getData();

		http(this.Api)
			.create(data, headers)
			.then((response) => {
				const fieldsContainer = this.Form.querySelector('.fields-container');
				if (fieldsContainer)
					fieldsContainer.style.display = 'none';

				const thankyou = this.Form.querySelector('.thankyou');
				if (thankyou)
					thankyou.style.display = 'block';

				this.onComplete();
			})
			.catch((e) => {
				console.error('Error: Download Guide', e);
				this.SubmitButton.value = 'Submit';
				this.SubmitButton.classList.remove('loading');
				this.ErrorContainer.innerHTML = `An error occurred while processing your request. Please try again.`;
			});
	}

	setToken(token) { }

	validateFields() {
		let isValid = true;

		for (let x in this.Fields) {
			if (this.Fields[x].required && this.Fields[x].element.value === '') {
				this.Fields[x].element.classList.add('error');
				isValid = false;
			}
			else
				this.Fields[x].element.classList.remove('error');
		}

		return isValid;
	}

	submit() {
		if (this.SubmitButton.value !== this.LoadingText) {

			this.SubmitButton.classList.add('loading');

			const isValid = this.validateFields();

			if (isValid) {
				this.SubmitButton.value = 'Loading';

				if (typeof this.CaptchaKey === 'string' && this.CaptchaKey.length > 0) {

					const fnSetToken = (token) => {
						this.setToken(token);
						this.sendLead();
					};

					if (!window.grecaptcha)
						loadCaptcha(this.CaptchaKey, fnSetToken);
					else
						getCaptchaToken(this.CaptchaKey, fnSetToken);

				} else {
					this.sendLead()
				}
			}
			else {
				this.SubmitButton.classList.remove('loading');
			}
		}
	}
}

class DownloadGuide extends WhitePaperForm {
	constructor(form) {
		super(form);

		this.Api = '/DownloadGuide';

		this.CaptchaKey = form.getAttribute('data-captchakey');

		this.Fields = {
			CaptchaToken: { element: { value: '' }, required: false },
			FirstName: { element: form.querySelector('input[name="first_name"]'), required: true },
			LastName: { element: form.querySelector('input[name="last_name"]'), required: true },
			Email: { element: form.querySelector('input[name="email"]'), required: true }
		};
	}

	setToken(token) {
		this.Fields.CaptchaToken.element.value = token;
	};

	validateFields() {
		const validation = formValidation('DownloadGuide', this.Form);

		return validation.validate();
	};
}

class Newsletter extends WhitePaperForm {
	constructor(form) {
		super(form);
		console.log("HELLO!")
		this.Form = form;

		this.Api = '/Newsletter';

		this.CaptchaKey = form.getAttribute('data-captchakey');

		this.ErrorContainer = form.querySelector('div.errors');
		if (!this.ErrorContainer)
			console.error("ArgumentNullException: ErrorContainer");

		this.Fields = {
			CaptchaToken: { element: { value: '' }, required: false },
			FirstName: { element: form.querySelector('input[name="FirstName"]'), required: true, message: "Moo!" },
			LastName: { element: form.querySelector('input[name="LastName"]'), required: true },
			Email: { element: form.querySelector('input[name="Email"]'), required: true },
			BusinessCountry: { element: form.querySelector('select[name="BusinessCountry"]'), required: true },
			UTM_AdGroup: { element: form.querySelector('input[name="UTM_AdGroup"]'), required: false },
			UTM_Campaign: { element: form.querySelector('input[name="UTM_Campaign"]'), required: false },
			UTM_Content: { element: form.querySelector('input[name="UTM_Content"]'), required: false },
			UTM_Medium: { element: form.querySelector('input[name="UTM_Medium"]'), required: false },
			UTM_Source: { element: form.querySelector('input[name="UTM_Source"]'), required: false }
		};

		this.ThankYouPage = form.querySelector('a.thankyou');

		if (!this.ErrorContainer)
			console.error("ArgumentNullException: ErrorContainer");
	}

	onComplete() {
		window.location.href = this.ThankYouPage.href;
	}

	setToken(token) {
		this.Fields.CaptchaToken.element.value = token;
	}

	validateFields() {
		this.ErrorContainer.innerHTML = '';

		const validation = formValidation('Newsletter', this.Form);

		return validation.validate();
	}
}

class TRS extends WhitePaperForm {
    constructor(form) {
        super(form);
        console.log("HELLO!")
        this.Form = form;

        this.Api = '/TRS';

        this.CaptchaKey = form.getAttribute('data-captchakey');

        this.ErrorContainer = form.querySelector('div.errors');
        if (!this.ErrorContainer)
            console.error("ArgumentNullException: ErrorContainer");

        this.Fields = {
            CaptchaToken: { element: { value: '' }, required: false },
            FirstName: { element: form.querySelector('input[name="FirstName"]'), required: true, message: "Moo!" },
            LastName: { element: form.querySelector('input[name="LastName"]'), required: true },
            Email: { element: form.querySelector('input[name="Email"]'), required: true },
            BusinessCountry: { element: form.querySelector('select[name="BusinessCountry"]'), required: true },
            UTM_AdGroup: { element: form.querySelector('input[name="UTM_AdGroup"]'), required: false },
            UTM_Campaign: { element: form.querySelector('input[name="UTM_Campaign"]'), required: false },
            UTM_Content: { element: form.querySelector('input[name="UTM_Content"]'), required: false },
            UTM_Medium: { element: form.querySelector('input[name="UTM_Medium"]'), required: false },
            UTM_Source: { element: form.querySelector('input[name="UTM_Source"]'), required: false }
        };

        this.ThankYouPage = form.querySelector('a.thankyou');

        if (!this.ErrorContainer)
            console.error("ArgumentNullException: ErrorContainer");
    }

    onComplete() {
        window.location.href = this.ThankYouPage.href;
    }

    setToken(token) {
        this.Fields.CaptchaToken.element.value = token;
    }

    validateFields() {
        this.ErrorContainer.innerHTML = '';

        const validation = formValidation('TRS', this.Form);

        return validation.validate();
    }
}

class RCOGuide extends WhitePaperForm {
	constructor(form) {
		super(form);

		this.Api = '/RCO';

		this.CaptchaKey = form.getAttribute('data-captchakey');

		this.Fields = {
			CaptchaToken: { element: { value: '' }, required: false },
			FirstName: { element: form.querySelector('input[name="first_name"]'), required: true },
			LastName: { element: form.querySelector('input[name="last_name"]'), required: true },
			Email: { element: form.querySelector('input[name="email"]'), required: true }
		};

		this.OptIn = form.querySelector('input[name="optIn"]');

		if (!this.OptIn)
			console.error("ArgumentNullException: OptIn");
	}

	getData() {
		const data = super.getData();
		data.OptIn = this.OptIn.checked ? 'true' : 'false';
		return data;
	}

	setToken(token) {
		this.Fields.CaptchaToken.element.value = token;
	}

	validateFields() {
		const validation = formValidation('RCO', this.Form);

		return validation.validate();
	}
}

function whitePaper(form, formType) {

	if (!form)
		console.error("ArgumentNullException: form");

	if (!formType)
		console.error("ArgumentNullException: formType");

	let whitepaper = undefined;

	switch (formType) {
		case 'RCOGuide':
			whitepaper = new RCOGuide(form);
			break;

		case 'DownloadGuide':
			whitepaper = new DownloadGuide(form);
			break;

		case 'Newsletter':
			whitepaper = new Newsletter(form);
			break;

        case 'TRS':
            whitepaper = new TRS(form);
            break;

        case 'Newsletter':
			whitepaper = new Cascadia(form);
	}

	if (!whitepaper)
		console.error(`NotImplementedException: ${formType}`)

	form.addEventListener('submit', event => {
		event.preventDefault();
		whitepaper.submit();
		return;
	});
}

function formData(form) {
	const data = new FormData(form);
	const params = new URLSearchParams(data);
	const serialized = params.toString();
	return serialized;
}

function validateSelect(select) {
	if (select.classList.contains('validate')) {
		select.classList.toggle('valid', !!select.value);
	}
}

function parseLocationValue(value) {
	if (typeof value === 'string')
		return value.toLowerCase()
			.replaceAll(' ', '-')
			.replaceAll(/[^0-9a-zA-Z-]/g, '');

	return '';
}

function isReferrerMatch(model) {
	const parsedModel = parseLocationValue(model);

	const referrer = document.referrer;
	if (referrer) {
		const matches = referrer.split('/')
			.filter(x => { return x !== '' && parseLocationValue(x) === parsedModel; });

		if (matches.length > 0)
			return true;
	}

	if (typeof URLSearchParams === 'function') {
		const urlParams = new URLSearchParams(window.location.search);
		const truck = urlParams.get('truck');
		if (truck && parsedModel === parseLocationValue(truck))
			return true;
	}

	return false;
}

async function locationCheck(container) {
	const { default: MapsLoader } = await import('load-google-maps-api'),
		{ default: _ } = await import('lodash'),
		Maps = await MapsLoader({
			v: '3.30',
			key: googleMapsKey,
			libraries: ['places']
		});
	var input = container.querySelector('input[location]'),
		errors = container.querySelector('.errors'),
		international = container.querySelector('[international] textarea'),
		address = container.querySelector('input[name="Address"]'),
		city = container.querySelector('input[name="City"]'),
		state = container.querySelector('input[name="State"]'),
		postalcode = container.querySelector('input[name="PostalCode"]'),
		country = container.querySelector('input[name="Country"]'),
		locationAutocomplete = new Maps.places.Autocomplete(input, { types: ['geocode'] });
	// When the user selects an address from the dropdown, populate the address
	// fields in the form.
	locationAutocomplete.addListener('place_changed', () => {
		const place = autocomplete.getPlace(),
			mailingAddress = _.chain(place.address_components).map(item => {
				return [item.types[0], item.long_name];
			}).fromPairs().value(),
			at = joinedAttributes(mailingAddress);

		if (!(mailingAddress.street_number && mailingAddress.route)) {
			errors.innerHTML = h('p', 'Please enter a more specific mailing address.').toString();
		}
		else {
			errors.innerHTML = '';
			if (['United States', 'Canada'].indexOf(mailingAddress.country) === -1 && mailingAddress.street_number && mailingAddress.route) {
				international.value = place.formatted_address;
				container.setAttribute('region', 'international');
			}
			else {
				container.setAttribute('region', 'national');
				address.value = at(['street_number', 'route'], ' ');
				city.value = at(['locality']);
				state.value = at(['administrative_area_level_1']);
				postalcode.value = at(['postal_code', 'postal_code_suffix'], '-');
				country.value = at(['country']);
			}
		}
	});
	function joinedAttributes(source) {
		return (paths, glue) => {
			glue = glue || '';
			return _.compact(paths.reduce(function (list, path) {
				return list.concat(_.at(source, path));
			}, [])).join(glue);
		}
	}
}

async function dealerSelect(container) {
	const { default: MapsLoader } = await import('load-google-maps-api'),
		Maps = await MapsLoader({
			v: '3.30',
			key: googleMapsKey,
			libraries: ['places']
		});
	let dealerInput = container.querySelector('input[location]'),
		errors = container.querySelector('[errors]'),
		dealer = container.querySelector('input[name="DealerCode"]'),
		header = container.querySelector('header'),
		headerDefaultText = header.textContent,
		allDealers = [],
		dealerArray = [],
		dealerFields = [
			'address',
			'city',
			'email',
			'name',
			'phone',
			'zip',
			'state',
			'isInternational',
			'website',
			'distance'
		],
		dealerList = container.querySelector('[dealers]'),
		dealerAutocomplete = new Maps.places.Autocomplete(dealerInput, { types: ['geocode'] }),
		addressFields,
		dealerApiAddress = (container.attributes['api-address'] && container.attributes['api-address'].value !== '')
			? container.attributes['api-address'].value : rootURL + '/dealers/GetByDistance';

	function filterDealers(dealers) {
		const filtered = [],
			selectedTruck = container.parentNode.querySelector('[name="TruckModel"]')?.value || '';

		// currently we're only applying logic for Cascadia trucks, all others leave unfiltered
		if (selectedTruck.toLowerCase().indexOf('cascadia') === -1)
			return dealers;

		dealers.forEach(x => {
			if (x.isInternational) {
				filtered.push(x);
			} else {
				var lowerCaseTrucks = x.slsSvcProdDescList
					.concat(x.slsOnlyProdDescList)
					.map(a => a.toLowerCase());
				if (lowerCaseTrucks.indexOf('cascadia') !== -1) {
					filtered.push(x);
				}
			}
		});
		return filtered;
	}

	function getAddressFields() {
		return addressFields || dealerFields.map(key => {
			return { Key: key, Object: container.querySelector('[name="Dealer[' + key + ']"]') };
		});
	}

	function getLocation() {
		var place = dealerAutocomplete.getPlace(),
			loc = place.geometry.location

		return {
			latitude: loc.lat(),
			longitude: loc.lng()
		};
	}

	function populateDealers(dealers, location = getLocation()) {
		dealerList.innerHTML = h('h6', dealers.length + ' nearest Results')
			('ul',
				dealers.reduce((html, dealer) => {
					dealer.distance = Math.round(getDistance(dealer.latitude, dealer.longitude, location.latitude, location.longitude));
					return html + h('li code="' + dealer.code + '"',
						h('label name', dealer.name)
							(dealer.city && dealer.state ? 'label address' : '', dealer.city + ', ' + dealer.state)
							('label distance', dealer.distance + ' Miles Away')
					)
				}, '')
			).toString();
	}

	function resetAddress() {
		header.textContent = headerDefaultText;
		header.classList.add('expanded');
		dealer.value = '';
		getAddressFields().forEach(field => {
			field.Object.value = '';
			if (field.Object.classList.contains('validate'))
				field.Object.className = 'validate';
		});
		[...container.querySelectorAll('li.selected')].forEach(li => li.classList.remove('selected'));

		if (allDealers.length > 0) {
			dealerArray = filterDealers(allDealers);
			populateDealers(dealerArray);
		}
	}

	// When the user selects an address from the dropdown, populate the address
	// fields in the form.
	dealerAutocomplete.addListener('place_changed', function () {
		const location = getLocation();
		errors.innerHTML = '';
		http(dealerApiAddress).get({
			...location,
			type: "FTL",
			count: 10,
			radius: 1000,
			source: 'requestquote'
		}).then(dealers => {
			allDealers = dealers;
			dealerArray = filterDealers(dealers);
			populateDealers(dealerArray, location);
		}).catch((error) => {
			console.error(error);
		});
	});

	container.parentNode.querySelector('[name="TruckModel"]')?.addEventListener('change', resetAddress);

	domWrap(container).on('click', 'li', function () {
		const dealerCode = this.getAttribute('code');
		dealer.value = dealerCode;
		const event = new Event("dealer-change", {});
		dealer.dispatchEvent(event);
		domWrap(this).setSelected();
		header.textContent = 'My Dealer: ' + this.querySelector('label').textContent;
		header.classList.remove('expanded');

		(dealer => {
			getAddressFields().forEach(field => {
				field.Object.value = dealer[field.Key];
				if (
					field.Object.classList.contains('validate')
					&& field.Object.validity.valid
				) {
					field.Object.classList.add('valid');
				}
			});
		})(dealerArray.find(item => item.code === dealerCode));

	});

	header.addEventListener('click', function () {
		header.classList.toggle('expanded');
	});
}